import PropTypes from 'prop-types'

export default function ValidationMessage({ children, type, className }) {
  return (
    <div className="tw-custom-uppercase tw-text-sm tw-text-system-grey-400 tw-my-1">
      {
        <>
          <span
            className={`tw-block ${className || ''} ${
              type === 'danger'
                ? 'tw-text-danger'
                : type === 'success'
                ? 'tw-text-success'
                : type === 'warning'
                ? 'tw-text-secondary'
                : ''
            }`}>
            {children || <>&nbsp;</>}
          </span>
        </>
      }
    </div>
  )
}

ValidationMessage.defaultProps = {
  type: 'default',
}

ValidationMessage.propTypes = {
  children: PropTypes.node,
  type: PropTypes.oneOf(['danger', 'default', 'success', 'warning']),
  // Classes for the message itself, for example to truncate it where the
  // space it has is limited
  className: PropTypes.string,
}
